module.exports = __webpack_public_path__ + "static/media/bw-social-yt.fe693be6.svg";